'use client';

import React, { useLayoutEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import { StickyProps } from './Sticky.types';
import { useScrollDirection } from '@frodo/lib/hooks/utility/useScrollDirection';

export const Sticky = ({
  className,
  children,
  stickyScrollUpClass,
  stickyScrollDownClass,
}: StickyProps) => {
  const stickyRef = useRef<HTMLDivElement>(null);
  const [originalY, setOriginalY] = useState<number | undefined>(undefined);
  const { direction, isPastOriginalPosition } = useScrollDirection({
    elementOriginalY: originalY,
  });

  useLayoutEffect(() => {
    if (!stickyRef.current) {
      return;
    }

    const { top } = stickyRef.current.getBoundingClientRect();
    setOriginalY(top + window.scrollY);
  }, []);

  const stickyClass = isPastOriginalPosition
    ? direction === 'up'
      ? stickyScrollUpClass
      : stickyScrollDownClass
    : undefined;

  return (
    <div ref={stickyRef} className={classnames(className, stickyClass)}>
      {children}
    </div>
  );
};
